import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";
import { Menu as JetMenu } from "@randajan/jet-react/dom/menu";

import { Router } from "../../../pages";

import "./Menu.scss";
import { Link } from '@randajan/jet-react/dom/link';
import Hamburger from "./menu.svg";
import { Img } from '@randajan/jet-react/dom/img';
import { screen } from '@randajan/jet-react/base/screen';



export const Menu = (props)=>{
    const [w960] = screen.use("960w");

    
    return (
        <JetMenu flat={w960.get()} trigger={<Img src={Hamburger}/>} transition={500} position="top">
            {Router.mapRoutes(({path, titleMenu})=>{
                if (!titleMenu) { return; }
                return <Link to={path}>{titleMenu}</Link>
            })}
        </JetMenu>
    )
}

